import React from 'react'
import injectStyles from 'react-jss'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import DateRangeSelector from '../../../Components/DateRangeSelector'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

const StyledTableRow = withStyles(theme => ({
  root: {
    backgroundColor: '#f8f8f8',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'white',
    },
    '&:first-child': {
      backgroundColor: 'white',
      '&>td': {
        fontSize: '18px',
      },
    },
  },
}))(TableRow)

const StyledTable = withStyles(theme => ({
  root: {
    border: 'none',
  },
}))(Table)

const StyledTableCell = withStyles(theme => ({
  root: {
    border: 'none',
    width: '30%',
    color: '#546b81 !important',
    fontSize: '16px',
    padding: 0,
  },
}))(TableCell)

const StyledTableBox = withStyles(theme => ({
  root: {
    padding: '16px 16px 16px 0',
    display: 'block',
  },
}))(Box)
const StyledTableBody = withStyles(theme => ({
  root: {
    backgroundColor: 'green',
  },
}))(TableBody)
const StatsKPIView = props => {
  const {
    classes,
    tablesData,
    setFirstRangeDates,
    setSecondRangeDates,
    firstRange,
    secondRange,
  } = props
  return (
    <section className={classes.wrapper}>
      <section>
        {tablesData.map(
          ({ table }) =>
            table.name == 'Current active BAs' && (
              <h3 className={classes.currentActiveBAs}>
                {table.name}
                {': '}
                {table.rows.map(row => (
                  <div className={classes.currentActiveBAsTab}>{row[2]}</div>
                ))}
              </h3>
            ),
        )}
      </section>
      <section className={classes.dates}>
        <div className={classes.datePickerContainer}>
          <h5 className={classes.datePickerContainerHeader}>
            First Date Range:
          </h5>
          <DateRangeSelector
            value={firstRange.startDate}
            onChange={value => {
              value && value.set({ hour: 0, minute: 0 })
              setFirstRangeDates({
                startDate: value,
                endDate: firstRange.endDate,
              })
            }}
          />

          <DateRangeSelector
            value={firstRange.endDate}
            onChange={value => {
              value && value.set({ hour: 23, minute: 29 })
              setFirstRangeDates({
                startDate: firstRange.startDate,
                endDate: value,
              })
            }}
          />
        </div>

        <div className={classes.datePickerContainer}>
          <h5>Second Date Range:</h5>
          <DateRangeSelector
            value={secondRange.startDate}
            onChange={value => {
              value && value.set({ hour: 0, minute: 0 })
              setSecondRangeDates({
                startDate: value,
                endDate: secondRange.endDate,
              })
            }}
          />
          <DateRangeSelector
            value={secondRange.endDate}
            onChange={value => {
              value && value.set({ hour: 23, minute: 29 })
              setSecondRangeDates({
                startDate: secondRange.startDate,
                endDate: value,
              })
            }}
          />
        </div>
      </section>

      <section className={classes.tablesContainer}>
        {tablesData.map(
          ({ table }) =>
            table.name != 'Current active BAs' && (
              <TableContainer>
                <StyledTable>
                  <h3 className={classes.tableName}>{table.name}</h3>
                  <StyledTableBody>
                    {table.rows.map(row => (
                      <StyledTableRow>
                        {row.map(value => (
                          <StyledTableCell>
                            <StyledTableBox>{value}</StyledTableBox>
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    ))}
                  </StyledTableBody>
                </StyledTable>
              </TableContainer>
            ),
        )}
      </section>
    </section>
  )
}

export default injectStyles(styles)(StatsKPIView)
